import React from 'react';
import { Modal, Button, Form, Input } from 'antd';

const EmailModal = ({ 
  visible, 
  customer, 
  onCancel, 
  onSendEmail 
}) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (customer) {
      form.setFieldsValue({
        to: customer.email,
        subject: '',
        message: '',
      });
    }
  }, [customer, form]);

  return (
    <Modal
      title={`Send Email to ${customer ? customer.firstName : ''}`}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button 
          key="back" 
          onClick={onCancel}
        >
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={() => {
            form.submit();
          }}
        >
          Send Email
        </Button>,
      ]}
    >
      <Form 
        form={form} 
        layout="vertical"
        onFinish={(values) => {
          onSendEmail(values);
          form.resetFields();
        }}
      >
        <Form.Item
          name="to"
          label="To"
        >
          <Input disabled />
        </Form.Item>
        
        <Form.Item
          name="subject"
          label="Subject"
          rules={[{ required: true, message: 'Please enter subject' }]}
        >
          <Input placeholder="Email Subject" />
        </Form.Item>
        
        <Form.Item
          name="message"
          label="Message"
          rules={[{ required: true, message: 'Please enter message' }]}
        >
          <Input.TextArea rows={6} placeholder="Email Content" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailModal;